const TOPICS = [
  { id: 1, name: '#韩漫推荐', heat: '🔥 12.8万讨论', desc: '韩国网漫爱好者聚集地' },
  { id: 2, name: '#日漫新番', heat: '🔥 9.6万讨论', desc: '每季新番追更交流' },
  { id: 3, name: '#下拉式阅读', heat: '⭐ 8.3万讨论', desc: '下拉式漫画阅读心得分享' },
  { id: 4, name: '#漫画安利', heat: '💬 7.1万讨论', desc: '互相推荐好看的漫画作品' },
  { id: 5, name: '#完结神作', heat: '🏆 6.5万讨论', desc: '已完结的经典漫画盘点' },
  { id: 6, name: '#画风鉴赏', heat: '🎨 5.2万讨论', desc: '优秀漫画画风赏析交流' },
  { id: 7, name: '#追更日记', heat: '📖 4.8万讨论', desc: '每日追更打卡与剧情讨论' },
  { id: 8, name: '#CP发糖', heat: '💕 4.3万讨论', desc: '漫画甜蜜CP互动分享' },
  { id: 9, name: '#漫画改编', heat: '🎬 3.9万讨论', desc: '漫改动画与真人剧讨论' },
  { id: 10, name: '#冷门佳作', heat: '💎 2.7万讨论', desc: '发掘被埋没的优秀漫画' },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100/80 text-accent-700 text-xs font-medium mb-3">
            热门话题
          </span>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950">漫画社区热门话题</h2>
          <p className="mt-2 text-foreground-600 text-sm md:text-base">加入讨论，和千万漫友一起畅聊下拉式漫画</p>
        </div>

        <div className="flex flex-wrap justify-center gap-3">
          {TOPICS.map((topic) => (
            <div
              key={topic.id}
              className="group flex flex-col items-start p-4 rounded-2xl bg-background-100 hover:bg-primary-50/50 transition-colors cursor-pointer w-full sm:w-[calc(50%-0.75rem)] lg:w-[calc(20%-0.75rem)] min-w-[180px]"
            >
              <span className="text-xs font-medium text-primary-500 mb-1.5 whitespace-nowrap">{topic.heat}</span>
              <span className="font-bold text-foreground-900 text-sm mb-1.5 group-hover:text-primary-500 transition-colors">
                {topic.name}
              </span>
              <span className="text-xs text-foreground-600">{topic.desc}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}